import { Injectable } from '@angular/core'
import { ToastrService } from 'ngx-toastr'

@Injectable({
  providedIn: 'root'
})
export class ShowErrorService {
  constructor(private toastrService: ToastrService) {}

  showHttpError(err: any) {
    // Model-state failures carry the field-level details (e.g. "notes: The field Notes must be...")
    // in extraDetails — far more actionable than the generic "error validating the model state".
    const validationErrors: string = err?.error?.extraDetails?.['validation-errors']
    const error: string = validationErrors || err?.error?.errorMessage
    if (error) {
      this.toastrService.error(error)
    } else {
      this.toastrService.error('You are offline or server error happend! Please try again later')
    }
  }
}
